var React = require('react');

function AsanaWarriorTwo (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","strokeWidth":"2","strokeMiterlimit":"10","d":"M0,15c0,0,11.563,0,13,0c3,0,2,3.25,2,9\n\tC6.197,31.812,2,37,2,37h2.063c0,0,12.25-7.625,15.292-8S27,29,27,29v8h5 M38,13H23c0,0,0-5.451,0-6c0-1.657-1.344-3-3-3\n\tc-1.657,0-3,1.343-3,3c0,0.549,0,2.451,0,3c0,2.836,1.043,3.903,4,5.306c1.469,0.696,2.25,1.525,2.25,2.694\n\tc0,1.252-0.25,2.518-0.25,5.875c0,0,3.253,0.322,6.313,1.008c1.034,0.231,1.749,0.867,1.749,2.055c0,1.563-1,10.063-1,10.063"}));
}

AsanaWarriorTwo.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"38px","height":"38px","viewBox":"0 0 38 38","enableBackground":"new 0 0 38 38","xmlSpace":"preserve"};

module.exports = AsanaWarriorTwo;

AsanaWarriorTwo.default = AsanaWarriorTwo;
